import { render, staticRenderFns } from "./RegulatoryUpdateAddNewAddress.vue?vue&type=template&id=68a46d4a&scoped=true"
import script from "./RegulatoryUpdateAddNewAddress.vue?vue&type=script&lang=ts"
export * from "./RegulatoryUpdateAddNewAddress.vue?vue&type=script&lang=ts"
import style0 from "./RegulatoryUpdateAddNewAddress.vue?vue&type=style&index=0&id=68a46d4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a46d4a",
  null
  
)

export default component.exports